import { type ApiClient } from "@anna-money/anna-web-lib/api";
import type { AuthStore } from "auth/authStore";
import type { AnalyticsManager } from "services/analytics/analyticsManager";

import {
  CompanyAbnCreateData,
  type CompanyCreateData,
  CompanyData,
  CompanyListData,
  CompanyNameUpdateData,
  type CompanyUpdateDataType,
} from "services/company/companyTypes";

export class CompanyClient {
  private readonly _apiClient: ApiClient;
  private readonly _authStore: AuthStore;
  private readonly _analyticsManager: AnalyticsManager;

  constructor(apiClient: ApiClient, authStore: AuthStore, analyticsManager: AnalyticsManager) {
    this._apiClient = apiClient;
    this._authStore = authStore;
    this._analyticsManager = analyticsManager;
  }

  async getCompany(): Promise<CompanyData | undefined> {
    const response = await this._apiClient.get("api/formations/companies");
    const companies = response.getData(CompanyListData);

    return companies.companies.length ? companies.companies[0] : undefined;
  }

  async createCompany(data?: CompanyCreateData | CompanyNameUpdateData | CompanyAbnCreateData): Promise<CompanyData> {
    const response = await this._apiClient.post("api/formations/companies", data);
    // Reset token refresh flag after company creation so the token
    // gets refreshed with company_id before reaching the payment step
    this._authStore.initTokenRefreshedFlag();
    this._analyticsManager.event("formation_token_refreshed_init");
    return response.getData(CompanyData);
  }

  async updateCompany(companyId: string, data: CompanyUpdateDataType): Promise<CompanyData> {
    const response = await this._apiClient.post(`api/formations/companies/${companyId}`, data);

    return response.getData(CompanyData);
  }
}
